(function($R)
{
    $R.lang["de"] = {
        "format": "Format",
        "image": "Bild",
        "file": "Datei",
        "link": "Link",
        "bold": "Fett",
        "italic": "Kursiv",
        "deleted": "Durchgestrichen",
        "underline": "Unterstrichen",
        "superscript": "Hochgestellt",
        "subscript": "Tiefgestellt",
        "bold-abbr": "B",
        "italic-abbr": "I",
        "deleted-abbr": "S",
        "underline-abbr": "U",
        "superscript-abbr": "Hoch",
        "subscript-abbr": "Tief",
        "lists": "Liste",
        "link-insert": "Link einfügen",
        "link-edit": "Link bearbeiten",
        "link-in-new-tab": "Link in neuem Tab öffnen",
        "unlink": "Link entfernen",
        "cancel": "Abbrechen",
        "close": "Schließen",
        "insert": "Einfügen",
        "save": "Speichern",
        "delete": "Löschen",
        "text": "Text",
        "edit": "Bearbeiten",
        "title": "Titel",
        "paragraph": "Normaler Text",
        "quote": "Zitat",
        "code": "Code",
        "heading1": "Überschrift 1",
        "heading2": "Überschrift 2",
        "heading3": "Überschrift 3",
        "heading4": "Überschrift 4",
        "heading5": "Überschrift 5",
        "heading6": "Überschrift 6",
        "filename": "Name",
        "optional": "Optional",
        "unorderedlist": "Aufzählung",
        "orderedlist": "Nummerierung",
        "outdent": "Einzug verkleinern",
        "indent": "Einzug vergrößern",
        "horizontalrule": "Linie",
        "upload": "Upload",
        "upload-label": "Bilder hier ablegen oder für Upload klicken",
        "upload-change-label": "Neues Bild hier ablegen",
        "accessibility-help-label": "Rich-Text-Editor",
        "caption": "Beschriftung",
        "bulletslist": "Aufzählung",
        "numberslist": "Nummerierung",
        "image-position": "Position",
        "none": "Keine",
        "left": "Links",
        "right": "Rechts",
        "center": "Mitte",
        "undo": "Rückgängig",
        "redo": "Wiederholen",

        /* Table plugin */
        "table": "Tabelle",
        "insert-table": "Tabelle einfügen",
        "insert-row-above": "Zeile oberhalb hinzufügen",
        "insert-row-below": "Zeile unterhalb hinzufügen",
        "insert-column-left": "Spalte links einfügen",
        "insert-column-right": "Spalte rechts einfügen",
        "add-head": "Tabellenrubrik einfügen",
        "delete-head": "Tabellenrubrik löschen",
        "delete-column": "Spalte löschen",
        "delete-row": "Zeile löschen",
        "delete-table": "Tabelle löschen",

        /* Fullscreen plugin */
        "fullscreen": "Vollbildanzeige",

        /* Font color plugin */
        "fontcolor": "Schriftfarbe",
        "highlight": "Hintergrundsfarbe",

        /* Font family plugin */
        "fontfamily": "Schriftfamilie",
        "remove-font-family": "Schriftart zurücksetzen",

        /* Font size plugin */
        "size": "Schriftgrösse",
        "remove-size": "Textgröße zurücksetzen",

        /* Imagemanager/Filemanager plugin */
        "choose": "Wählen",

        /* Alignment plugin */
        "align": "Ausrichten",
        "align-left": "Text links ausrichten",
        "align-center": "Text zentrieren",
        "align-right": "Text rechts ausrichten",
        "align-justify": "Text ausrichten",
            
        /* Video plugin */
        "video": "Video",
        "video-html-code": "Video von Youtube oder Vimeo einbetten"
    };
})(Redactor);